import { useRequiredContext } from "@redotech/react-util/context";
import { RedoMerchantRpcClientContext } from "@redotech/redo-merchant-app-common/rpc-client";
import { TeamContext } from "@redotech/redo-web/context/team-context";
import { useQuery } from "@tanstack/react-query";
import { getCustomAnalyticsReportQueryKey } from "./use-custom-analytics-report-query";

export function getCustomAnalyticsReportStructureQueryKey(
  teamId: string,
  customReportId: string,
) {
  return [
    ...getCustomAnalyticsReportQueryKey(teamId, customReportId),
    "structure",
  ] as const;
}

export function useCustomAnalyticsReportStructureQuery(customReportId: string) {
  const team = useRequiredContext(TeamContext);
  const rpcClient = useRequiredContext(RedoMerchantRpcClientContext);
  return useQuery({
    queryKey: getCustomAnalyticsReportStructureQueryKey(
      team._id,
      customReportId,
    ),
    queryFn: ({ signal }) =>
      rpcClient.getCustomAnalyticsReportStructure(
        { id: customReportId },
        { signal },
      ),
    staleTime: 5 * 60 * 1000,
    refetchOnMount: "always",
    refetchOnWindowFocus: true,
    refetchInterval: (query) =>
      query.state.data?.status === "preparing"
        ? 2 * 1000
        : query.state.data?.status === "ready"
          ? 5 * 60 * 1000
          : false,
  });
}
